const booleanValue = value => (typeof value === 'boolean' || value === undefined ? value : value === 'S' ? 'S' : 'N');

export default booleanValue;
